// src/components/auth/SignUpLink.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import Button from '../ui/Button';

export default function SignUpLink({
  className = '',
  variant = 'primary',
  size = 'sm',
  children = 'Create account',
}) {
  const { pathname, search, hash } = useLocation();
  const next = `${pathname}${search}${hash || ''}`;
  const qs = next ? `?next=${encodeURIComponent(next)}` : '';

  return (
    <Button
      as="link"
      to={`/create-account${qs}`}
      variant={variant}
      size={size}
      className={className}
    >
      {children}
    </Button>
  );
}